module.exports = __webpack_public_path__ + "static/media/13.a3157b5d.jpg";